module.exports = __webpack_public_path__ + "static/media/image01.fa6c3767.webp";